<p-panel>
	<app-reactive-form-builder
		#builderRef
		(stableValueChanges)="stableValueChanges($event)"
		(internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
		(afterSend)="onAfterSend($event)"
		(goBack)="goBack()"
		[form]="form.formFields"
		[id]="getRegisterId()"
		[request]="request"
		[getRequest]="trabajadoresApi.trabajadoresGET"
	>
	</app-reactive-form-builder>
</p-panel>
